"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inventoryLogSubtypes = exports.InventoryLogSubtypeForOCS = exports.InventoryLogSubtypeForBlaze = exports.InventoryLogSubtypeForDB = exports.ComplianceInventoryLogType = exports.InventoryLogType = void 0;
var InventoryLogType;
(function (InventoryLogType) {
    InventoryLogType["SALE"] = "sale";
    InventoryLogType["PURCHASE_ORDER"] = "purchase order";
    InventoryLogType["TRANSFER"] = "transfer";
    InventoryLogType["REFUND"] = "refund";
    InventoryLogType["CONVERT"] = "convert";
    InventoryLogType["AUDIT"] = "audit";
    InventoryLogType["LOST"] = "lost";
    InventoryLogType["DESTROYED"] = "destroyed";
    InventoryLogType["RETURN"] = "return";
})(InventoryLogType || (exports.InventoryLogType = InventoryLogType = {}));
// Only for compliance reports
var ComplianceInventoryLogType;
(function (ComplianceInventoryLogType) {
    ComplianceInventoryLogType["SALE"] = "sale";
    ComplianceInventoryLogType["PURCHASE_ORDER"] = "purchase order";
    ComplianceInventoryLogType["TRANSFER"] = "transfer";
    ComplianceInventoryLogType["REFUND"] = "refund";
    ComplianceInventoryLogType["CONVERT"] = "convert";
    ComplianceInventoryLogType["AUDIT"] = "audit";
    ComplianceInventoryLogType["LOST"] = "lost";
    ComplianceInventoryLogType["DESTROYED"] = "destroyed";
    ComplianceInventoryLogType["RETURN"] = "return";
    ComplianceInventoryLogType["OTHER_ADDITIONS"] = "otherAdditions";
    ComplianceInventoryLogType["OTHER_REDUCTIONS"] = "otherReductions";
})(ComplianceInventoryLogType || (exports.ComplianceInventoryLogType = ComplianceInventoryLogType = {}));
var InventoryLogSubtypeForDB;
(function (InventoryLogSubtypeForDB) {
    InventoryLogSubtypeForDB["PHYSICAL_INV_COUNT_OPERATIONAL"] = "phInvCoOper";
    InventoryLogSubtypeForDB["PHYSICAL_INV_COUNT_AGCO"] = "phInvCoAGCO";
    InventoryLogSubtypeForDB["DATA_ENTRY_ERROR"] = "dataEntryErr";
    InventoryLogSubtypeForDB["SOLD_PRODUCT_HANDLING_ERROR"] = "soldProdHandErr";
    InventoryLogSubtypeForDB["RECEIVING_ERROR"] = "receivingErr";
    InventoryLogSubtypeForDB["CYCLE_COUNT"] = "cycleCo";
    InventoryLogSubtypeForDB["INTERNAL_AUDIT"] = "intAudit";
})(InventoryLogSubtypeForDB || (exports.InventoryLogSubtypeForDB = InventoryLogSubtypeForDB = {}));
var InventoryLogSubtypeForBlaze;
(function (InventoryLogSubtypeForBlaze) {
    InventoryLogSubtypeForBlaze["PHYSICAL_INV_COUNT_OPERATIONAL"] = "Physical Inventory Count (Operationally Initiated)";
    InventoryLogSubtypeForBlaze["PHYSICAL_INV_COUNT_AGCO"] = "Physical Inventory Count (AGCO Initiated)";
    InventoryLogSubtypeForBlaze["DATA_ENTRY_ERROR"] = "Data Entry Error";
    InventoryLogSubtypeForBlaze["SOLD_PRODUCT_HANDLING_ERROR"] = "Sold Product Handling Error";
    InventoryLogSubtypeForBlaze["RECEIVING_ERROR"] = "Receiving Error";
    InventoryLogSubtypeForBlaze["CYCLE_COUNT"] = "Cycle Count";
    InventoryLogSubtypeForBlaze["INTERNAL_AUDIT"] = "Internal Audit";
})(InventoryLogSubtypeForBlaze || (exports.InventoryLogSubtypeForBlaze = InventoryLogSubtypeForBlaze = {}));
var InventoryLogSubtypeForOCS;
(function (InventoryLogSubtypeForOCS) {
    InventoryLogSubtypeForOCS["PHYSICAL_INV_COUNT_OPERATIONAL"] = "Physical Inventory Count (Operationally Initiated)";
    InventoryLogSubtypeForOCS["PHYSICAL_INV_COUNT_AGCO"] = "Physical Inventory Count (AGCO Initiated)";
    InventoryLogSubtypeForOCS["DATA_ENTRY_ERROR"] = "Data Entry Error";
    InventoryLogSubtypeForOCS["SOLD_PRODUCT_HANDLING_ERROR"] = "Sold Product Handling Error";
    InventoryLogSubtypeForOCS["RECEIVING_ERROR"] = "Receiving Error";
    InventoryLogSubtypeForOCS["CYCLE_COUNT"] = "Cycle Count";
    InventoryLogSubtypeForOCS["INTERNAL_AUDIT"] = "Internal Audit";
})(InventoryLogSubtypeForOCS || (exports.InventoryLogSubtypeForOCS = InventoryLogSubtypeForOCS = {}));
exports.inventoryLogSubtypes = {
    phInvCoOper: {
        dbVal: InventoryLogSubtypeForDB.PHYSICAL_INV_COUNT_OPERATIONAL,
        blazeVal: InventoryLogSubtypeForBlaze.PHYSICAL_INV_COUNT_OPERATIONAL,
        ocsVal: InventoryLogSubtypeForOCS.PHYSICAL_INV_COUNT_OPERATIONAL,
    },
    phInvCoAGCO: {
        dbVal: InventoryLogSubtypeForDB.PHYSICAL_INV_COUNT_AGCO,
        blazeVal: InventoryLogSubtypeForBlaze.PHYSICAL_INV_COUNT_AGCO,
        ocsVal: InventoryLogSubtypeForOCS.PHYSICAL_INV_COUNT_AGCO,
    },
    dataEntryErr: {
        dbVal: InventoryLogSubtypeForDB.DATA_ENTRY_ERROR,
        blazeVal: InventoryLogSubtypeForBlaze.DATA_ENTRY_ERROR,
        ocsVal: InventoryLogSubtypeForOCS.DATA_ENTRY_ERROR,
    },
    soldProdHandErr: {
        dbVal: InventoryLogSubtypeForDB.SOLD_PRODUCT_HANDLING_ERROR,
        blazeVal: InventoryLogSubtypeForBlaze.SOLD_PRODUCT_HANDLING_ERROR,
        ocsVal: InventoryLogSubtypeForOCS.SOLD_PRODUCT_HANDLING_ERROR,
    },
    receivingErr: {
        dbVal: InventoryLogSubtypeForDB.RECEIVING_ERROR,
        blazeVal: InventoryLogSubtypeForBlaze.RECEIVING_ERROR,
        ocsVal: InventoryLogSubtypeForOCS.RECEIVING_ERROR,
    },
    cycleCo: {
        dbVal: InventoryLogSubtypeForDB.CYCLE_COUNT,
        blazeVal: InventoryLogSubtypeForBlaze.CYCLE_COUNT,
        ocsVal: InventoryLogSubtypeForOCS.CYCLE_COUNT,
    },
    intAudit: {
        dbVal: InventoryLogSubtypeForDB.INTERNAL_AUDIT,
        blazeVal: InventoryLogSubtypeForBlaze.INTERNAL_AUDIT,
        ocsVal: InventoryLogSubtypeForOCS.INTERNAL_AUDIT,
    },
};
//# sourceMappingURL=inventoryLog.js.map